// 手机号校验
export function phoneNumValid(phoneNumber) {
  const reg = /^1\d{10}$/;
  return reg.test(phoneNumber);
}
//判断验证码 6位
export function CodeValid(str) {
  const reg = /^\d{6}$/;
  return reg.test(str);
}
//全为空格的校验
export function allBlankSpaceValid(Space) {
  const reg = /^\s+$/g;
  return Space.match(reg);
}
